import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

const SWATCH_BASE = 'tw:size-6 tw:rounded-md! tw:border tw:border-solid '
  + 'tw:border-gray-300 tw:cursor-pointer tw:p-0'
const SWATCH_SELECTED = 'tw:ring-2 tw:ring-offset-1 tw:ring-ds-neutral-highest'

const Swatch = ({ color, selected, disabled, onSelect }) => {
  const handleClick = useCallback(() => onSelect(color), [onSelect, color])

  return (
    <button
      aria-label={`Couleur ${color}`}
      aria-pressed={selected}
      className={`${SWATCH_BASE} ${selected ? SWATCH_SELECTED : ''}`}
      disabled={disabled}
      style={{ backgroundColor: color }}
      type="button"
      onClick={handleClick}
    />
  )
}

Swatch.propTypes = {
  color: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired
}

export default Swatch
